// gestion des cookies depuis le service externe axeptio

const element = document.querySelector('.open-axeptio')

if (element) {
  element.addEventListener(
    'click',
    (e) => {
      window.openAxeptioCookies()
      e.preventDefault()
    },
    false,
  )
}

// chargement d'axeptio
window.axeptioSettings = {
  clientId: '63b3fb8280c468d083aa5063',
  googleConsentMode: {
    default: {
      analytics_storage: 'denied',
      ad_storage: 'denied',
      ad_user_data: 'denied',
      ad_personalization: 'denied',
      wait_for_update: 500,
    },
  },
  cookiesVersion:
    'edd-' + document.querySelector('html').getAttribute('lang') || 'fr',
}
;(function (d, s) {
  var t = d.getElementsByTagName(s)[0],
    e = d.createElement(s)
  e.async = true
  e.src = '//static.axept.io/sdk.js'
  t.parentNode.insertBefore(e, t)
})(document, 'script')
